import { useState } from "react";
import { Button, TextField } from "@mui/material";
// import "../../../styles/StartAConversation.css";
import TabLayout from "../../../lib/bandung/components/helpers/TabLayout";
import StarIcon from '@mui/icons-material/Star';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { useTheme } from "../../Theme";

function InboxTab() {
  const [url, setUrl] = useState("");
  const [view, setView] = useState('card');
  const { darkMode, toggleModes } = useTheme();

  const ThemeClasses = darkMode
    ? "border-white-300 text-white"
    : "border-cyan-800 text-black";

  // Function to handle View Mode
  const handleChangeViewMode = (mode) => {
    setView(mode);
  }

  const handleChange = (e) => setUrl(e.target.value);


  const data = [
    { name: "Supplier 1", type: "Metallurgy", rating: 4, button: "View Profile" },
    { name: "Supplier 2", type: "Metallurgy", rating: 2, button: "View Profile" },
    { name: "Supplier 3", type: "Metallurgy", rating: 3, button: "View Profile" },
    { name: "Supplier 3", type: "Metallurgy", rating: 1, button: "View Profile" },
    { name: "Supplier 3", type: "Metallurgy", rating: 4, button: "View Profile" },

  ]

   // Function to render the Star Icons based on rating
   const renderStars = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <StarIcon
          key={i}
          style={{ color: i < rating ? 'gold' : 'gray', fontSize: '20px' }}
        />
      );
    }
    return stars;
  };


  // To get the ListItems on ListView
  const ListItems = ({ company }) => (
    <div className="Task self-stretch py-2.5 border-t border-neutral-200 justify-start items-center gap-20 w-[1000px]  inline-flex hover:shadow-lg transition-transform transform hover:-translate-y-1">
      <img className="Image w-62 h-28 relative rounded-lg" src={`${process.env.PUBLIC_URL}/assets/images/company_name.jpg`} />
      <div className="Suppliers p-5 w-full">
        <div className="SupplierInfo flex justify-between pb-5 items-center w-full">
          <div className="Product self-stretch text-xl font-medium font-['Inter'] justify-center leading-loose">{company.name}</div>
          <div className="Favourite gap-50 justify-end flex pr-3">
            <FavoriteBorderIcon className="text-gray-500" />
          </div>
        </div>
        <div className="Pill pr-10  justify-start items-center flex pb-7">
          <div className="Tag self-stretch px-2 py-1.5 bg-white rounded-lg border border-neutral-200 justify-center items-center gap-2 inline-flex">
            <div className="Label text-black text-md font-semibold text-zinc-500 font-['Inter']  leading-none">{company.type}</div>
          </div>
        </div>
        <div className="Pill pr-4 justify-start items-center flex">
        </div>
        <div className="Stars flex space-x-1 pt-1 pb-4">
          {renderStars(company.rating)}
        </div>
        <div className={`Tag self-stretch px-4 py-3  rounded-lg border  justify-center items-center gap-2 inline-flex  hover:bg-cyan-800 ${ThemeClasses}`}>
          <div className={`Button text-md font-semibold font-['Inter'] leading-none text-cyan-800 hover:text-white ${ThemeClasses}`}>{company.button}</div>
        </div>
      </div>
    </div>
  );

  // To get the CardItems on ListView
  const CardItems = ({ company }) => (
    <div className="Card w-60 h-92 self-stretch flex-col justify-start items-start gap-4 inline-flex border border-gray-300 rounded-lg hover:shadow-lg transition-transform transform hover:-translate-y-1 ">
            <img className="Image w-72 h-28 relative rounded-lg" src={`${process.env.PUBLIC_URL}/assets/images/company_name.jpg`} />
            <div className="Copy pl-4 self-stretch flex-col justify-center items-start  flex">
                <div className="SupplierInfo flex justify-between items-center w-full">
                    <div className="Product self-stretch  text-lg font-medium font-['Inter'] justify-center leading-loose">{company.name}</div>
                    <div className="Favourite gap-50 justify-end flex pr-3">
                        <FavoriteBorderIcon className="text-gray-500" />
                    </div>
                </div>
                <div className="TypeOfCompany self-stretch text-zinc-500 text-l font-medium font-['Inter'] pb-8 leading-loose">{company.type}</div>
                <div className="Stars flex space-x-1 pt-1 pb-4">
                    {renderStars(company.rating)}
                </div>
                <div className="ViewProfile pb-4">
                    <div className={`Tag px-4 py-3  rounded-lg border justify-center items-center gap-2 inline-flex  hover:bg-cyan-800 ${ThemeClasses}`}>
                        <div className={`Button text-md font-semibold font-['Inter'] leading-none text-cyan-800 hover:text-white ${ThemeClasses}`}>{company.button}</div>
                    </div>
                </div>
            </div>

        </div>
  );


  return (
    <div className="InboxResult h-96 relative">
      <div className="Results w-48 h-5 left-[50px] top-[16px] absolute  text-2xl font-bold font-['Inter'] leading-normal">Inbox Results</div>
      <div className="ButtonsContainer flex absolute gap-4 left-[80%] top-[0px] transform -translate-x-1/2  md:left-[500px] lg:left-[700px] xl:left-[800px] gap-4">
        <div
          className={`Button w-20 h-12 px-6 py-3.5 rounded-lg shadow justify-center items-center gap-2 flex cursor-pointer ${view === 'card' ? 'bg-cyan-800' : 'bg-white border border-black'}`}
          onClick={() => handleChangeViewMode('card')}
        >
          <div className={`Card text-base font-medium font-['Inter'] leading-normal ${view === 'card' ? 'text-white' : 'text-black'}`}>Card</div>
        </div>
        <div
          className={`Button w-20 h-12 px-6 py-3.5 rounded-lg shadow justify-center items-center gap-2 flex cursor-pointer ${view === 'list' ? 'bg-cyan-800' : 'bg-white border border-black'}`}
          onClick={() => handleChangeViewMode('list')}
        >
          <div className={`List text-base font-medium font-['Inter'] leading-normal ${view === 'list' ? 'text-white' : 'text-black'}`}>List</div>
        </div>
      </div>

      {view === 'list' ? (
        <div className="List w-200 h-70 left-[50px] top-[70px]  absolute flex-col justify-start pb-10 items-start inline-flex cursor-pointer ">
          <div className="List h-12 flex-col sm:h-70 left-0 sm:left-[50px] top-[70px] justify-start items-start flex">
            {data.map((company, index) => (
              <ListItems key={index} company={company} />

            ))}
          </div>
        </div>
      ) : (
        <div className="CardGrid w-full absolute left-0  items-center top-[100px] left-[50px] pb-10 flex flex-wrap  items-start gap-10 cursor-pointer">
          {data.map((company, index) => (
            <CardItems key={index} company={company} />
          ))}
        </div>
      )}
    </div>
  );
}



export default InboxTab;



